"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _flagsInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flags");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.FeatureFlagPane = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _AppPanel = require("@uifabric/portal-ux/lib/AppPanel");

var _Link = require("@fluentui/react/lib/Link");

var _Toggle = require("@fluentui/react/lib/Toggle");

var React = _interopRequireWildcard(require("react"));

var _featureFlags = require("../../feature-flags");

var optionsStyles = require('../../Options/OptionsPane/Options.scoped.scss');
/**
 * Internal use only: Represents a feature flag configuration screen enabled in dev mode
 */


var FeatureFlagPane = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FeatureFlagPane, _React$Component);

  var _super = (0, _createSuper2.default)(FeatureFlagPane);

  function FeatureFlagPane(nextProps) {
    var _this;

    (0, _classCallCheck2.default)(this, FeatureFlagPane);
    _this = _super.call(this, nextProps);

    _this._resetFlags = function () {
      _flagsInstanceProperty(_featureFlags).resetOverrides();

      _this.setState({
        flags: _flagsInstanceProperty(_featureFlags).get()
      });
    };

    var featureFlags = _flagsInstanceProperty(_featureFlags).get();

    _this.state = {
      flags: featureFlags
    };
    return _this;
  }

  (0, _createClass2.default)(FeatureFlagPane, [{
    key: "render",
    value: function render() {
      var _context,
          _this2 = this;

      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          dismiss = _this$props.dismiss; // This control is only debugging flights and feature settings
      // It should NOT have localized strings as it is internal use only

      var featureFlags = _flagsInstanceProperty(_featureFlags).get();

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_AppPanel.AppPanel, {
        isOpen: isOpen,
        headerText: "Feature flags",
        onDismiss: dismiss,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: optionsStyles.section,
          children: 'Microsoft internal use only'
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
          onClick: this._resetFlags,
          children: 'Reset'
        }), (0, _map.default)(_context = (0, _keys.default)(featureFlags)).call(_context, function (flag) {
          var toggled = function toggled(checked) {
            _flagsInstanceProperty(_featureFlags).saveOverride(flag, checked);

            _this2.setState({
              flags: (0, _objectSpread3.default)((0, _objectSpread3.default)({}, featureFlags), {}, (0, _defineProperty2.default)({}, flag, checked))
            });
          };

          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: optionsStyles.section,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toggle.Toggle, {
              label: flag,
              checked: featureFlags[flag],
              onChanged: toggled
            })
          }, flag);
        })]
      });
    }
  }]);
  return FeatureFlagPane;
}(React.Component);

exports.FeatureFlagPane = FeatureFlagPane;